export class Viewport {
  // >50% visible (vertically)
  static above(targetEl: HTMLElement): boolean {
    const rect = targetEl.getBoundingClientRect()
    const breakpoint = rect.height / 2

    return rect.bottom < breakpoint
  }

  // >50% visible (vertically)
  static below(targetEl: HTMLElement): boolean {
    const rect = targetEl.getBoundingClientRect()
    const breakpoint = rect.height / 2
    const height = window.innerHeight || document.documentElement.clientHeight

    return rect.top > height - breakpoint
  }

  // >0% visible
  static in(targetEl: HTMLElement): boolean {
    const rect = targetEl.getBoundingClientRect()
    const height = window.innerHeight || document.documentElement.clientHeight
    const width = window.innerWidth || document.documentElement.clientWidth

    const leftVisible = rect.left >= 0 && rect.left <= width
    const rightVisible = rect.right >= 0 && rect.right <= width
    const leftOrRightVisible = leftVisible || rightVisible

    const topVisible = rect.top >= 0 && rect.top <= height
    const bottomVisible = rect.bottom >= 0 && rect.bottom <= height
    const topOrBottomVisible = topVisible || bottomVisible

    return leftOrRightVisible && topOrBottomVisible
  }

  // >50% visible (vertically)
  static viewable(targetEl: HTMLElement): boolean {
    return (
      Viewport.in(targetEl) &&
      !Viewport.below(targetEl) &&
      !Viewport.above(targetEl)
    )
  }
}
